<style>
 
  @import 'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css';

  table td  span.tag {text-decoration:none}
</style>



<template>
  <div id="app">
    <component :is="layout">

    </component>
  </div>
</template>



<script>
const default_layout = "default";

export default {
  name: 'Nav',
  computed: {
      layout() {
        return (this.$route.meta.layout || default_layout) + '-layout';
      }
    }
}

/*
document.addEventListener('DOMContentLoaded', () => {

  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

});*/
</script>

<style >
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

html.has-navbar-fixed-top {padding-top:68px !important;}

.sidebar-container {background:#F9F9F9;border-right:1px solid #ddd}
.sticky-sidebar {position:sticky;top:68px;}
</style>
